import React from 'react';
import { Box, ChakraProvider, theme, useColorModeValue } from '@chakra-ui/react';
import { ToastContainer } from 'react-toastify';
import ContextWrapper from './state/DataContext/DataContext';
import Routes from './Routes';
import "react-datepicker/dist/react-datepicker.css";
import "./index.css"
import "./device.min.css"
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  return (
    <ChakraProvider theme={theme}>
      <Box background={useColorModeValue("gray.50", "gray.700")} minHeight="100vh">
        <ContextWrapper>
          <ToastContainer />

          {/* Handle different views with <Routes/> */}
          <Routes />

        </ContextWrapper>
      </Box >
    </ChakraProvider >
  );
}

export default App;
